// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "87ef564fbe775a46913e4efe7da6184284af9420/scripts/" + chunkId + ".js";
};